import gql from 'graphql-tag';

export const CREATE_OR_UPDATE_SETTING = gql`
  mutation CreateOrUpdateSetting($input: CreateOrUpdateSettingInput!) {
    createOrUpdateSetting(input: $input) {
      id
    }
  }
`;
